// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"564":"5dfd056c","760":"f49f73cb","787":"5a249c66"}[chunkId] + ".chunk.js";
};